import { Route } from '@angular/router';
import {
  REQUEST_CONTEXT_ADAPTER,
  VENDOR_ROUTES,
  VendorRequestContextAdapter,
} from '@kuiper/ibusiness-core';

export const vendorRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: VENDOR_ROUTES.VENDOR_DATA,
  },
  {
    path: VENDOR_ROUTES.ACCOUNT_SETTINGS.MAIN,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../pages/vendor-flow/vendor-account-setting/vendor-account-setting.component').then(
            m => m.VendorAccountSettingComponent
          ),
      },
      {
        path: VENDOR_ROUTES.ACCOUNT_SETTINGS.EDIT_PROFILE.replace('/', ''),
        loadComponent: () =>
          import('../pages/vendor-flow/vendor-account-setting/edit-vendor-profile/edit-vendor-profile.component').then(
            m => m.EditVendorProfileComponent
          ),
      },
    ],
  },
  {
    path: VENDOR_ROUTES.VENDOR_DATA,
    loadComponent: () =>
      import('../pages/vendor-flow/vendor-data/vendor-data.component').then(
        m => m.VendorDataComponent
      ),
  },
  {
    path: VENDOR_ROUTES.INVOICES.MAIN,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: VENDOR_ROUTES.INVOICES.LIST,
      },
      {
        path: VENDOR_ROUTES.INVOICES.LIST,
        loadComponent: () =>
          import('../pages/vendor-flow/invoice/vendor-invoice-list.component').then(
            m => m.VendorInvoiceListComponent
          ),
      },
      {
        path: `${VENDOR_ROUTES.INVOICES.DETAILS}/:id`,
        loadComponent: () =>
          import('../pages/vendor-flow/invoice/vendor-invoice-details/vendor-invoice-details.component').then(
            m => m.VendorInvoiceDetailsComponent
          ),
      },
    ],
  },
  {
    path: VENDOR_ROUTES.CONTRACTS.MAIN,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: VENDOR_ROUTES.CONTRACTS.LIST,
      },
      {
        path: VENDOR_ROUTES.CONTRACTS.LIST,
        loadComponent: () =>
          import('../pages/vendor-flow/contracts/contract-list/vendor-contract-list.component').then(
            m => m.VendorContractListComponent
          ),
      },
      {
        path: `${VENDOR_ROUTES.CONTRACTS.DETAILS}/:contractId`,
        loadComponent: () =>
          import('../pages/vendor-flow/contracts/vendor-contract-details/vendor-contract-details.component').then(
            m => m.VendorContractDetailsComponent
          ),
      },
    ],
  },
  {
    path: VENDOR_ROUTES.MY_INBOX.ASSIGNED_TASKS,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../pages/vendor-flow/my-tasks/my-tasks.component').then(
            m => m.MyTasksComponent
          ),
      },
      {
        path: ':stepId/:requestAction/:flowId',
        loadComponent: () =>
          import('@kuiper/ibusiness-core').then(m => m.RequestComponent),
        providers: [
          {
            provide: REQUEST_CONTEXT_ADAPTER,
            useExisting: VendorRequestContextAdapter,
          },
        ],
      },
    ],
  },
];
